<template>
	<div class = "data_box page_padding">
		<span>成交金额<i class = "iconfont" style="margin-left: 0.5vw;">&#xe693;</i></span>
		<div class = "divider"></div>
		<span class = "display_title">交易金额<span style="color:#ff6f00;font-size: 1.4vw;font-weight: 800;">{{systemData.statisticData.settlementPriceSum.toFixed(2)}}</span>元</span>
		<div  class = "divider"></div>
		<span class = "display_title">累计订单<span style="color:#ff6f00;font-size: 1.4vw;font-weight: 800;">{{systemData.statisticData.orderCount}}</span>单 </span>
		<div class = "divider"></div>
		<span class = "display_title">会员人数<span style="color:#ff6f00;font-size: 1.4vw;font-weight: 800;">{{systemData.statisticData.supplierCount}}</span>人</span>
		
	</div>
</template>

<script>
	import {mapGetters} from 'vuex'
	export default{
		
		data(){
			return {
				
			}
		},
		computed:{
			...mapGetters(['systemData'])
		},
		created() {
			
			
			
			
		}
		
		
		
		
	}
</script>

<style>
	.divider{
		width: 0.104vw;
			height: 4.063vw;
			background-color: #efefef;
	}
	.data_box{
		height: 6.25vw;
		display: flex;
		justify-content: space-around;
		align-items: center;
		background-color: #FFFFFF;
	}
	.data_box>span:nth-child(1){
		
	
			height: 1.198vw;
			
			font-size: 1.25vw;
			font-weight: normal;
			font-stretch: normal;
			line-height: 1.875vw;
			letter-spacing: 0vw;
			color: #ff6f00;
		
		
	}
	.display_title{
		
			height: 1.302vw;
			font-family: PingFangSC-Regular;
			font-size: 0.938vw;
			font-weight: normal;
			font-stretch: normal;
			line-height: 1.875vw;
			letter-spacing: 0vw;
			color: #999999;
		
		
	}
	
</style>
